const { PanelBody, PanelRow, Button, ToggleControl, TextControl } = wp.components;
const { __ } = wp.i18n;

import BControlPro from "../../../../components/BControlPro";
import BMediaUpload from "../../BMediaUpload";
import PremiumText from "../../PremiumText";

const Subtitle = ({ setAttributes, attributes, isPremium, updateOption }) => {
  const { captionEnabled, subtitle, options } = attributes;

  const handleSubtitle = (property, value, index) => {
    const newSubtitle = [...subtitle];
    newSubtitle[index] = { ...newSubtitle[index], [property]: value };
    setAttributes({ subtitle: newSubtitle });
  };

  const removSubtitle = (index) => {
    const newSubtitle = [...subtitle];
    newSubtitle.splice(index, 1);
    setAttributes({ subtitle: newSubtitle });
  };

  return (
    <PanelBody className="subtitlePanel" title={__("Subtitle/Caption", "h5vp")} initialOpen={false}>
      <PremiumText isPremium={isPremium} />
      {isPremium &&
        subtitle.map((item, index) => {
          return (
            <PanelBody key={index} title={item.label} initialOpen={false} className="subtitleItem">
              {/* <PanelRow className="width-100"> */}
              <TextControl value={item?.label} onChange={(label) => handleSubtitle("label", label, index)} placeholder={"Caption Label"} />
              {/* </PanelRow> */}
              <BMediaUpload
                // type={["audio/mp3"]}
                onSelect={(source) => handleSubtitle("caption_file", source, index)}
                value={item?.caption_file}
                placeholder="Subtitle File"
              />
              <PanelRow>
                <span></span>
                <Button className="button button-danger button-small" onClick={() => removSubtitle(index)}>
                  {__("Remove", "h5vp")}
                </Button>
              </PanelRow>
            </PanelBody>
          );
        })}
      <PanelRow>
        <span></span>
        <Button
          isPrimary
          className="button button-small"
          onClick={() => {
            setAttributes({ subtitle: [...subtitle, { label: "label" }] });
          }}
        >
          {__("Add More", "h5vp")}
        </Button>
      </PanelRow>
      {subtitle && (
        <BControlPro
          isPremium={isPremium}
          Component={ToggleControl}
          label={__("Enable caption by default (Experimental)", "h5vp")}
          id="captionEnabled"
          checked={options.captions.enabled}
          onChange={() => updateOption({ captions: { ...options.captions, enabled: !options.captions.enabled } })}
        />
      )}
    </PanelBody>
  );
};

export default Subtitle;
